import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Search, Bell } from "lucide-react";
import SearchBarMobile from "./SearchBarMobile";
import NotificationPanelMobile from "./NotificationPanelMobile";

interface HeaderMobileProps {
  searchQuery: string;
  setSearchQuery: (value: string) => void;
  isSearchVisible: boolean;
  setIsSearchVisible: (value: boolean) => void;
  setIsMenuOpen: (value: boolean) => void;
  handleSearch: (e: React.FormEvent) => void;
  scrolled: boolean;
}

const HeaderMobile: React.FC<HeaderMobileProps> = ({
  searchQuery,
  setSearchQuery,
  isSearchVisible,
  setIsSearchVisible,
  setIsMenuOpen,
  handleSearch,
  scrolled,
}) => {
  const [isNotificationsVisible, setIsNotificationsVisible] = useState(false);
  const [unreadNotificationsCount] = useState(2);

  const handleBellClick = () => {
    setIsNotificationsVisible(true);
  };

  return (
    <>
      <header
        className={`lg:hidden fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${scrolled
          ? "bg-white/95 backdrop-blur-md shadow-lg border-b border-gray-100"
          : "bg-white border-b border-gray-100"
          }`}
      >
        <div className="px-4 py-2">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2">
              <img
                src="/assets/logo/notextfavicon.jpeg"
                alt="Kayovex"
                className="w-8 h-8 object-contain rounded-lg"
              />
              <div className="flex flex-col">
                <span className="text-sm font-semibold text-gray-800">
                  Kayovex
                </span>
                <span className="text-[10px] text-gray-500 -mt-0.5">Marketplace</span>
              </div>
            </Link>

            {/* Boutons actions avec dégradé primary/secondary */}
            <div className="flex items-center gap-2">
              <button
                onClick={() => setIsSearchVisible(!isSearchVisible)}
                className="relative p-2 rounded-full bg-gradient-to-r from-primary/10 to-secondary/10 border border-primary/20 shadow-sm hover:shadow-md transition-all duration-200 active:scale-95 hover:from-primary/20 hover:to-secondary/20"
                aria-label="Rechercher"
              >
                <Search className="w-[18px] h-[18px] text-primary hover:text-primary-dark transition-colors" />
              </button>

              <button
                onClick={handleBellClick}
                className="relative p-2 rounded-full bg-gradient-to-r from-primary/10 to-secondary/10 border border-primary/20 shadow-sm hover:shadow-md transition-all duration-200 active:scale-95 hover:from-primary/20 hover:to-secondary/20"
                aria-label="Notifications"
              >
                <Bell className="w-[18px] h-[18px] text-primary hover:text-primary-dark transition-colors" />

                {unreadNotificationsCount > 0 && (
                  <>
                    <span className="absolute top-0 right-0 w-2.5 h-2.5 bg-red-500 rounded-full animate-pulse ring-2 ring-white" />
                    <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[9px] font-bold min-w-[16px] h-[16px] flex items-center justify-center rounded-full px-0.5 shadow-sm">
                      {unreadNotificationsCount > 9 ? "9+" : unreadNotificationsCount}
                    </span>
                  </>
                )}
              </button>
            </div>

          </div>
        </div>
      </header>

      <div className="h-[60px] lg:hidden" />

      <SearchBarMobile
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        handleSearch={handleSearch}
        isSearchVisible={isSearchVisible}
        setIsSearchVisible={setIsSearchVisible}
      />

      <NotificationPanelMobile
        isNotificationsVisible={isNotificationsVisible}
        setIsNotificationsVisible={setIsNotificationsVisible}
      />
    </>
  );
};

export default HeaderMobile;